import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { Button, Row } from 'seagull';
import { AnchorLogo } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useIoContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
import styles from './GenericError.module.scss';
export const GetGenericErrorTID = (parentTestId)=>getTestIds(parentTestId);
export default function GenericError(props) {
    const { testId, fullPage } = props;
    const { t: genericErrorTexts } = useLocaleKeys('components.genericError');
    const { native, browser, cookies } = useIoContext();
    const { reset } = useStoreActions();
    const { GenericErrorTestIds } = useMemo(()=>GetGenericErrorTID(testId), [
        testId
    ]);
    const showResetApp = native.isNative && !!fullPage;
    function resetApp() {
        reset(true);
        cookies.clearAuthToken();
        browser.changeLocation(browser.getOrigin());
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.root, {
            [styles.fullPage]: fullPage
        }),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ _jsx(AnchorLogo, {
                className: styles.logo
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.text,
                children: genericErrorTexts.message()
            }),
            showResetApp && /*#__PURE__*/ _jsx(Row, {
                justifyContent: "center",
                children: /*#__PURE__*/ _jsx(Button, {
                    bi: {
                        name: 'reset_app'
                    },
                    testId: GenericErrorTestIds.ResetButton(),
                    onClick: resetApp,
                    children: genericErrorTexts.resetApp()
                })
            })
        ]
    });
}
